import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeDropdownResult, ProjectStatus, Result, ResultList, SecurityLevelEnum, StartProjectDetailResult, StartProjectResult } from 'app/models';
import { EmployeeService, StartProjectDetailService, StartProjectService } from 'app/services';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-start-project-detail-list',
  templateUrl: './start-project-detail-list.component.html',
  styleUrls: ['./start-project-detail-list.component.scss']
})
export class StartProjectDetailListComponent implements OnInit {
  public result: Result = new Result();
  public isBusy: boolean;

  public utility = Utility;
  public projectStatus = ProjectStatus;

  public startProjectResult = new StartProjectResult();
  public startProjectDetailResultList: ResultList<StartProjectDetailResult>;

  private startProjectId: number = 0;

  private idForDelete: number = 0;
  public startProjectIdForHistory = 0;
  public customerProjectId: number | null = null;
  public assignedEmployeeId: number | null = null;
  public assignedEmployee = new EmployeeDropdownResult();
  public startProjectDetail: StartProjectDetailResult | null = null;

  public customerProjectIdIsInvalid = false;
  public assignedEmployeeIdIsInvalid = false;

  public token = '';

  public addStartProjectDetailButton = false;
  public editStartProjectDetailButton = false;
  public updateAssigneeForStartProjectDetailButton = false;
  public updateProjectStatusButton = false;
  public deleteStartProjectDetailButton = false;

  public employeeDropdown = new Array<EmployeeDropdownResult>();

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private employeeService: EmployeeService,
    private _coreSidebarService: CoreSidebarService,
    private startProjectService: StartProjectService,
    private startProjectDetailService: StartProjectDetailService
  ) {
    this.isBusy = false;

    this.result = new Result();
    this.token = Utility.getTokenType();
    this.startProjectDetailResultList = new ResultList<StartProjectDetailResult>();
  }

  ngOnInit(): void {
    if (this.token === 'dashboardToken') {
      this.employeeService.checkPermission().then(permissionResult => {
        if (permissionResult.success !== true)
          this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
        else if (Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.StartProjectList) === true) {
          this.addStartProjectDetailButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.AddStartProjectDetail) ?? false;
          this.editStartProjectDetailButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.EditStartProjectDetail) ?? false;
          this.updateAssigneeForStartProjectDetailButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.UpdateAssigneeForStartProjectDetail) ?? false;
          this.updateProjectStatusButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.UpdateProjectStatus) ?? false;
          this.deleteStartProjectDetailButton = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.DeleteStartProjectDetail) ?? false;

          this.params();
          this.loadEmployeeDropdown();
        }
      }).catch(() => {
        this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
      });
    } else {
      this.params();
    }
  }

  private loadEmployeeDropdown(): void {
    this.employeeService.getEmployeeDropdown()
      .then(result => {
        if (result.success === true) {
          this.employeeDropdown = result.data;
        } else {
          this.result = result;
        }
      });
  }

  private params(): void {
    this.activatedRoute.params.forEach(param => {
      if (param.hasOwnProperty('startProjectId') === true) {
        this.startProjectId = +param['startProjectId'];
      }
    });
    this.loadStartProjectData();
    this.loadData();
  }

  private loadStartProjectData(): void {
    this.startProjectService.getStartProject(this.startProjectId, this.token).then(result => {
      if (result.success === true) {
        this.startProjectResult = result.data;
      } else {
        this.result = result;
      }
    });
  }

  public loadData(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.startProjectDetailService.getStartProjectDetail(this.startProjectId ?? 0, this.token).then(result => {
        if (result.success === true) {
          this.startProjectDetailResultList = result;
        } else {
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public openAlertModal(modalDanger: any, id: number): void {
    this.idForDelete = id;
    this.modalService.open(modalDanger, {
      centered: true,
      windowClass: 'modal modal-danger'
    });
  }

  public delete(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.startProjectDetailService.deleteStartProjectDetail(this.idForDelete).then(result => {
        this.isBusy = false;
        this.result = result;
        if (result.success === true) {
          this.result.message = Utility.DeleteOperationMessage;
          this.modalService.dismissAll();
          this.loadData();
        }
        else {
          this.modalService.dismissAll();
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public showData(startProjectDetail: StartProjectDetailResult): void {
    this.startProjectDetail = startProjectDetail;
    this._coreSidebarService.getSidebarRegistry('start-project-detail')!.toggleOpen();
  }

  public addData(): void {
    const temp = new StartProjectDetailResult();
    temp.startProjectId = this.startProjectId;
    this.showData(temp);
  }

  public demonstrateHistory(historyModal: any, id: number): void {
    if (this.isBusy === false) {
      this.startProjectIdForHistory = id;
      this.modalService.open(historyModal, {
        centered: true,
        size: 'lg',
        windowClass: 'modal modal-info'
      });
    }
  }
}
